import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Rightmenu from "../Mainpage/Rightmenu/Rightmenu";
import Write from "./Write";

function WritePost(props) {
    return(

        <div>
            <Container style={{marginTop:'30px'}}>
                <Row>
                    <Col xs={8}><Write></Write></Col>
                    <Col xs={4}><Rightmenu></Rightmenu></Col>
                </Row>
            </Container>
        </div>

    )
}

export default WritePost